import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCategories } from '../../services/categories';

const CategoryCarousel = () => {
  const [categories, setCategories] = useState([]);
  const scrollRef = React.useRef(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getCategories();
        const topLevel = data.filter((cat) => !cat.parentId);
        setCategories(topLevel);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, []);

  if (categories.length === 0) {
    return null;
  }

  return (
    <section className="py-5 sm:py-7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-4">
          <h2 className="text-2xl sm:text-3xl font-semibold">Giyim Kategorileri</h2>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth pb-4"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="flex-none w-[200px] sm:w-[240px]"
            >
              <div className="bg-gray-100 rounded-lg overflow-hidden">
                {category.image ? (
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-40 object-cover"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-full h-40 bg-gray-200" />
                )}
              </div>
              <div className="mt-3 text-sm font-medium text-gray-900">
                {category.name}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryCarousel;
